import { przezmorzeApi, throwMessageOnStatuses } from "../../../api/api";
import type {
  CreateRegionRequest,
  Region,
  RegionImage,
  RegionListResponse,
  UpdateRegionRequest,
} from "@przezmorze/api-types";

export type { CreateRegionRequest, Region, RegionImage, UpdateRegionRequest };

export interface ReorderRegionDto {
  readonly id: string;
  readonly order: number;
}

export interface ReorderRegionsDto {
  reorders: ReorderRegionDto[];
}

export async function listRegions(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<RegionListResponse>("/regions", {
    signal: abortSignal,
  });
  return response.data.items;
}

export async function addRegion(body: CreateRegionRequest, abortSignal?: AbortSignal) {
  try {
    const response = await przezmorzeApi.post<Region>("/regions", body, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [400, 409]);
  }
}

export async function updateRegion(id: string, body: UpdateRegionRequest, abortSignal?: AbortSignal) {
  try {
    const response = await przezmorzeApi.put<Region>(`/regions/${id}`, body, {
      signal: abortSignal,
    });
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [400]);
  }
}

export async function deleteRegion(id: string, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.delete<void>(`/regions/${id}`, {
    signal: abortSignal,
  });
  return response.data;
}

export async function reorderRegion(reorders: ReorderRegionDto[], abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.put<ReorderRegionsDto>(
    `/regions/reorder`,
    { reorders },
    {
      signal: abortSignal,
    },
  );
  return response.data;
}
